import type * as React from "react";
import { Empty, EmptyState } from "../../components/ui/empty";
import type { DataTableEmptyProps } from "./data-table-types";

/**
 * Empty state component for DataTable.
 * Displays when there are no rows to show.
 *
 * A preset of EmptyState: `circle` media — a table's empty state sits inside
 * a panel that already owns card chrome, so the `icon` card-chip art would
 * paint a competing card-colored box on it.
 *
 * `message` is the whole text of the caption-only form (a filter or search that
 * matched nothing). With a `title` it is not a fallback subtitle: a "No Accounts
 * yet" heading over "No results." reads as two states at once, so a titled empty
 * shows only the description it was given.
 */
export function DataTableEmpty({
  title,
  description,
  icon = "table",
  action,
  message = "No results.",
  children,
}: DataTableEmptyProps): React.ReactElement {
  if (children) {
    return <Empty className="flex-1">{children}</Empty>;
  }
  return (
    <EmptyState
      actions={action}
      className="flex-1"
      description={description ?? (title ? undefined : message)}
      icon={icon}
      media="circle"
      title={title}
    />
  );
}
